import React from "react";
import Home from "./pages/home";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./components/header";
import About from "./pages/about";
import Services from "./pages/services";
import Contact from "./pages/contact";
import Career from "./pages/career";
import CallFormButton from "./components/callformbutton";
import Callform from "./components/callform";
import LegalNotice from "./pages/legalNotice";
import PrivacyPolicy from "./pages/privacyPolicy";
import Termsandconditions from "./pages/termsandconditions";
import ScrollToTop from "./components/scrolltotop";
import Gallery from "./pages/gallery";
import Scheduleacall from "./components/scheduleacall";
import Customsoftwaredevelopment from "./pages/customsoftwaredevelopment";
import Error from "./pages/error";
import WebDevelopmentService from "./pages/web-development-service";
import MobileAppDevelopmentService from "./pages/mobile-app-development-service";
import ECommerceDevelopment from "./pages/e-commerce-development";
import HireDedicatedTeam from "./pages/hireServices";
import ImplementationAndDeployment from "./pages/implementationanddeployment";
import ApiIntegration from "./pages/apiIntegration";
import UiUx from "./pages/uiux";
import Mvp from "./pages/mvp-development";
import CloudServices from "./pages/cloudservices";
import TechnicalDSupport from "./pages/technicalsupport";
import Digitalmarketing from "./pages/digitalmarketing";
import SeoService from "./pages/seoservice";
import SocialMedia from "./pages/socialmedia";
import GooleAds from "./pages/googleads";
import OnDemandDeveloper from "./pages/ondemanddeveloper";
import OnPageSeo from "./pages/onPageSeo";
import OffPageSeo from "./pages/offpageseo";
import TechnicalSeo from "./pages/technicalSeo";
import ClientTestimonials from "./pages/clienttestimonials";
import SiteMap from "./pages/siteMap";
import ApplicationMaintenance from "./pages/applicationMaintenance";
import DataMigration from "./pages/datamigration";
import ItInfrastructure from "./pages/it-infrastructure";
import SoftwareSecurity from "./pages/softwaresecurity";
import Productmanagementlifecycle from "./pages/productlifecycle";
import QaTesting from "./pages/qatesting";
import Ourteam from "./pages/ourteam";
import GalleryNew from "./pages/gallerynew";
import Portfolio from "./pages/portfolio";
import SoftwareDevelopmentService from "./pages/SoftwareDevelopmentService";
import CarpelLaunchBanner from "./components/CarpelLaunchBanner/CarpelLaunchBanner";

function App() {
  return (
    <Router>
      <div className="">
        <CarpelLaunchBanner />
        <Header />
        <CallFormButton />
        <Callform />
        <Scheduleacall />
        <ScrollToTop />
        <div>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/service" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/career" element={<Career />} />
            <Route path="/gallery" element={<GalleryNew />} />
            <Route path="/legalnotice" element={<LegalNotice />} />
            <Route path="/privacypolicy" element={<PrivacyPolicy />} />
            <Route path="/termsandconditions" element={<Termsandconditions />} />
            <Route path="/custom-software-development-company" element={<Customsoftwaredevelopment />} />
            <Route path="/api-integration" element={<ApiIntegration />} />
            <Route path="/best-ui-ux-design-services" element={<UiUx />} />
            <Route path="/mvp-development" element={<Mvp />} />
            <Route path="/cloud-services" element={<CloudServices />} />
            <Route path="/web-development-services" element={<WebDevelopmentService />} />
            <Route path="/software-development-company-noida-india" element={<SoftwareDevelopmentService />} />
            <Route path="/mobile-app-development-services" element={<MobileAppDevelopmentService />} />
            <Route path="/e-commerce-development-services" element={<ECommerceDevelopment />} />
            <Route path="/hire-dedicated-team" element={<HireDedicatedTeam />} />
            <Route path="/implementation-and-deployment" element={<ImplementationAndDeployment />} />
            <Route path="/technical-it-support" element={<TechnicalDSupport />} />
            <Route path="/digital-marketing-services" element={<Digitalmarketing />} />
            <Route path="/search-engine-optimization-services-india" element={<SeoService />} />
            <Route path="/social-media-marketing-india" element={<SocialMedia />} />
            <Route path="/google-ads-services-india" element={<GooleAds />} />
            <Route path="/on-demand-developer" element={<OnDemandDeveloper />} />
            <Route path="/on-page-seo-services" element={<OnPageSeo />} />
            <Route path="/off-page-seo-services" element={<OffPageSeo />} />
            <Route path="/technical-seo-services" element={<TechnicalSeo />} />
            <Route path="/clients-testimonials" element={<ClientTestimonials />} />
            <Route path="/sitemap" element={<SiteMap />} />
            <Route path="/application-maintenance-services" element={<ApplicationMaintenance />} />
            <Route path="/data-migration-services" element={<DataMigration />} />
            <Route path="/it-infrastructure-services" element={<ItInfrastructure />} />
            <Route path="/software-security-services" element={<SoftwareSecurity />} />
            <Route path="/product-lifecycle-management-services" element={<Productmanagementlifecycle />} />
            <Route path="/qa-testing-services" element={<QaTesting />} />
            <Route path="/ourteam" element={<Ourteam />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="*" element={<Error />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
